// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import UpdateIcon from '@material-ui/icons/Update'

import './index.css'

export default class UpdateAvailableToast extends Component {

  render () {
    return (
      <div className='div-toast container'>
        <div className='row'>
          <div>
            <span>There is new Verimatrix software available</span>
          </div>
          <div>
            <button className='btn-reload' onClick={() => window.location.reload(false)}><UpdateIcon/>&nbsp;Update now</button>
          </div>
        </div>
      </div>
    )
  }
}

